import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiTrendingUp, FiClock } from 'react-icons/fi';

const MaximizeGuide = () => {
  return (
    <section className="py-20 bg-blue-600 rounded-[3rem] my-20 p-8 md:p-16 text-white overflow-hidden relative">
      <div className="relative z-10 max-w-2xl">
        <h2 className="text-4xl font-black mb-8 tracking-tighter uppercase italic">Maximize Your Results</h2>
        <div className="space-y-8">
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <SafeIcon icon={FiCheckCircle} />
            </div>
            <div>
              <h4 className="font-bold text-xl mb-2">The 2-Week Rule</h4>
              <p className="text-blue-100 text-sm">Calculators are starting points. Follow the calories for 14 days, track your weight, and adjust by 100kcal based on real-world changes.</p>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <SafeIcon icon={FiClock} />
            </div>
            <div>
              <h4 className="font-bold text-xl mb-2">Consistent Weigh-ins</h4>
              <p className="text-blue-100 text-sm">Weigh yourself daily under the same conditions (morning, fasted) and use a weekly average to calculate your true metabolic trend.</p>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <SafeIcon icon={FiTrendingUp} />
            </div>
            <div>
              <h4 className="font-bold text-xl mb-2">Activity Honesty</h4>
              <p className="text-blue-100 text-sm">Most people overestimate activity. If you work a desk job but hit the gym 3x a week, "Lightly Active" is usually more accurate than "Moderate".</p>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
    </section>
  );
};

export default MaximizeGuide;